import { 
  SET_COMPANY_TAB,
  SET_LOCATION_TAB,
  SET_REMOVAL_TAB,
  SET_INSPECTION_STATE,
  RESET_INSPECTION_STATE,
  RESET_INSPECTION_TAB_TRANSLATIONS
} from '../actions/start-inspection';
import __ from '../helpers/translation';

let defaultState = { 
  'companyTab': {
    active: true,
    disabled: false,
    complete: false,
    title: __('app.inspections.tab_companies')
  },
  'locationTab': {
    active: false,
    disabled: true,
    complete: false,
    title: __('app.inspections.tab_locations')
  },
  'removalTab': {
    active: false,
    disabled: true,
    complete: false,
    title: __('app.inspections.tab_removals')
  },
  'currentTab': 'companies',
  'next': false,
  'previous': false,
  'selectedCompany': null,
  'selectedLocation': null,
  'selectedSublocation': null,
  'selectedRemoval': null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_COMPANY_TAB:
      return Object.assign({}, state, { companyTab: { ...state.companyTab, ... action.tab }});
    case SET_LOCATION_TAB:
      return Object.assign({}, state, { locationTab: { ...state.locationTab, ... action.tab }});
    case SET_REMOVAL_TAB:
      return Object.assign({}, state, { removalTab: { ...state.removalTab, ... action.tab }});
    case SET_INSPECTION_STATE:
      return Object.assign({}, state, { ...action.data });
    case RESET_INSPECTION_STATE:
      return Object.assign({}, state, defaultState);
    case RESET_INSPECTION_TAB_TRANSLATIONS:
      return Object.assign({}, state, {
        companyTab: { ...state.companyTab, ...{title: __('app.inspections.tab_companies')} },
        removalTab: { ...state.removalTab, ...{title: __('app.inspections.tab_locations')} },
        locationTab: { ...state.locationTab, ...{title: __('app.inspections.tab_removals')} },
      });
    case 'USER_LOGOUT':
      return Object.assign({}, state, defaultState);
    default:
      return state;
  }
};
